import React from "react";
import { useEffect, useState } from "react";
import imageGeneratorService from "../services/imageGeneratorService";
import NavBar from "../components/NavBar";
import Container from "react-bootstrap/esm/Container";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/Button";
import "../css/generalcard.css";

function Install() {
	const [imageResult, setImageResult] = useState({
		imageUrl: "",
		createdBy: "",
		linkToProfile: "",
	});
	const onImageSuccess = (response) => {
		const randomIndex = Math.floor(Math.random() * response.results.length);

		const randomImage = response.results[randomIndex];

		const imageUrl = randomImage.urls.full;

		setImageResult((prevState) => {
			let ps = { ...prevState };
			ps.imageUrl = imageUrl;
			ps.createdBy = randomImage.user.name;
			ps.linkToProfile = randomImage.user.links.html;
			return ps;
		});
	};

	const onImageFailed = (error) => {
		console.log(error);
	};

	const handleSubmit = (event) => {
		event.preventDefault();

		const googleStoreUrl = `https://www.bing.com/`;

		//redirect
		window.location.href = googleStoreUrl;
	};

	useEffect(() => {
		imageGeneratorService
			.getBackGroundImage()
			.then(onImageSuccess)
			.catch(onImageFailed);
	}, []);

	return (
		<>
			<div
				style={{
					backgroundImage: `url(${imageResult.imageUrl})`,
					backgroundSize: "cover",
					backgroundRepeat: "no-repeat",
					height: "100vh",
				}}
			>
				<NavBar></NavBar>
				<Container className="h-25"></Container>
				<Container className="px-5">
					<Row>
						<Card className="h-100 bg-black opacity-75">
							<Card.Body>
								<Card.Title className="d-flex justify-content-around">
									<h1 className="border-bottom">Workout Tab</h1>
								</Card.Title>
								<Card.Text className="d-flex justify-content-around">
									<h3>Workout backgrounds and plans for your browser.</h3>
								</Card.Text>
								<Card.Text className="d-flex justify-content-around">
									<Button onClick={handleSubmit} size="lg">
										Click me to install.
									</Button>
								</Card.Text>

								<Card.Text className="d-flex justify-content-around ">
									<p>
										{" "}
										The search features used within the extension will be
										provided by Microsoft Bing.
										<br />
										Free stock media content is distributed by Unsplash -
										https://unsplash.com/
									</p>
								</Card.Text>
							</Card.Body>
						</Card>
					</Row>
				</Container>
				<a
					href={imageResult.linkToProfile}
					style={{
						position: "absolute",
						bottom: "10px",
						left: "10px",
						color: "white",
						textDecoration: "underline",
					}}
				>
					Credit to: {imageResult.createdBy}
				</a>
			</div>
		</>
	);
}

export default Install;
